import { httpErrorHandler } from '../../common/functions/helpers';
import { checkAutoEnrolmentStatus, fetchCategories, fetchLanguages, fetchServices, submitForm } from './appService';

export const APP_ACTIONS = {
  UPDATE_LOADING: 'APP_ACTIONS.UPDATE_LOADING',
  UPDATE_FORM_STARTED: 'APP_ACTIONS.UPDATE_FORM_STARTED',
  UPDATE_FORM_COMPLETED: 'APP_ACTIONS.UPDATE_FORM_COMPLETED',
  UPDATE_EDITING: 'APP_ACTIONS.UPDATE_EDITING',
  UPDATE_ERROR: 'APP_ACTIONS.UPDATE_ERROR',
  UPDATE_ERROR_MESSAGE: 'APP_ACTIONS.UPDATE_ERROR_MESSAGE',
  UPDATE_URLS: 'APP_ACTIONS.UPDATE_URLS',
  UPDATE_REPRESENTATIVE: 'APP_ACTIONS.UPDATE_REPRESENTATIVE',
  UPDATE_SERVICES: 'APP_ACTIONS.UPDATE_SERVICES',
  UPDATE_CATEGORIES: 'APP_ACTIONS.UPDATE_CATEGORIES',
  UPDATE_SERVICES_REQUIRED: 'APP_ACTIONS.UPDATE_SERVICES_REQUIRED',
  UPDATE_REASONS_REQUIRED: 'APP_ACTIONS.UPDATE_REASONS_REQUIRED',
  UPDATE_SERVICES_ERROR: 'APP_ACTIONS.UPDATE_SERVICES_ERROR',
  UPDATE_CATEGORIES_ERROR: 'APP_ACTIONS.UPDATE_CATEGORIES_ERROR',
  UPDATE_CODE_WORD: 'APP_ACTIONS.UPDATE_CODE_WORD',
  UPDATE_TEMPORARY_LIFE_CHANGE_END_DATE: 'APP_ACTIONS.UPDATE_TEMPORARY_LIFE_CHANGE_END_DATE',
  UPDATE_POST_HOSPITAL_RECOVERY_END_DATE: 'APP_ACTIONS.UPDATE_POST_HOSPITAL_RECOVERY_END_DATE',
  UPDATE_YOUNG_HOUSE_HOLDER_END_DATE: 'APP_ACTIONS.UPDATE_YOUNG_HOUSE_HOLDER_END_DATE556',
  UPDATE_LANGUAGE: 'APP_ACTIONS.UPDATE_LANGUAGE',
  UPDATE_LANGUAGES: 'APP_ACTIONS.UPDATE_LANGUAGES',
  UPDATE_LANGUAGES_ERROR: 'APP_ACTIONS.UPDATE_LANGUAGES_ERROR',
  UPDATE_ADDITIONAL_REQUIREMENTS: 'APP_ACTIONS.UPDATE_ADDITIONAL_REQUIREMENTS',
  UPDATE_AUTO_ENROL: 'APP_ACTIONS.UPDATE_AUTO_ENROL',
  RESET_APP: 'APP_ACTIONS.RESET_APP',
};

export const updateFormStarted = (value) => ({
  type: APP_ACTIONS.UPDATE_FORM_STARTED,
  payload: value,
});

export const updateFormCompleted = (value) => ({
  type: APP_ACTIONS.UPDATE_FORM_COMPLETED,
  payload: value,
});

export const updateIsEditing = (value) => ({
  type: APP_ACTIONS.UPDATE_EDITING,
  payload: value,
});

export const updateIsLoading = (value) => ({
  type: APP_ACTIONS.UPDATE_LOADING,
  payload: value,
});

export const updateError = (value) => ({
  type: APP_ACTIONS.UPDATE_ERROR,
  payload: value,
});

export const updateErrorMessage = (value) => ({
  type: APP_ACTIONS.UPDATE_ERROR_MESSAGE,
  payload: value,
});

export const updateUrls = (value) => ({
  type: APP_ACTIONS.UPDATE_URLS,
  payload: value,
});

export const updateRepresentative = (value) => ({
  type: APP_ACTIONS.UPDATE_REPRESENTATIVE,
  payload: value,
});

export const updateServices = (value) => ({
  type: APP_ACTIONS.UPDATE_SERVICES,
  payload: value,
});

export const updateCategories = (value) => ({
  type: APP_ACTIONS.UPDATE_CATEGORIES,
  payload: value,
});

export const updateServicesRequired = (value) => ({
  type: APP_ACTIONS.UPDATE_SERVICES_REQUIRED,
  payload: value,
});

export const updateReasonsRequired = (value) => ({
  type: APP_ACTIONS.UPDATE_REASONS_REQUIRED,
  payload: value,
});

export const updateServicesError = (value) => ({
  type: APP_ACTIONS.UPDATE_SERVICES_ERROR,
  payload: value,
});

export const updateCategoriesError = (value) => ({
  type: APP_ACTIONS.UPDATE_CATEGORIES_ERROR,
  payload: value,
});

export const updateCodeWord = (value) => ({
  type: APP_ACTIONS.UPDATE_CODE_WORD,
  payload: value,
});

export const updateTemporaryLifeChangeEndDate = (value) => ({
  type: APP_ACTIONS.UPDATE_TEMPORARY_LIFE_CHANGE_END_DATE,
  payload: value,
});

export const updatePostHospitalRecoveryEndDate = (value) => ({
  type: APP_ACTIONS.UPDATE_POST_HOSPITAL_RECOVERY_END_DATE,
  payload: value,
});

export const updateYoungHouseHolderEndDate = (value) => ({
  type: APP_ACTIONS.UPDATE_YOUNG_HOUSE_HOLDER_END_DATE,
  payload: value,
});

export const updateLanguage = (value) => ({
  type: APP_ACTIONS.UPDATE_LANGUAGE,
  payload: value,
});

export const updateLanguages = (value) => ({
  type: APP_ACTIONS.UPDATE_LANGUAGES,
  payload: value,
});

export const updateLanguagesError = (value) => ({
  type: APP_ACTIONS.UPDATE_LANGUAGES_ERROR,
  payload: value,
});

export const updateAutoEnrol = (value) => ({
  type: APP_ACTIONS.UPDATE_AUTO_ENROL,
  payload: value,
});

export const updateAdditionalRequirements = (value) => ({
  type: APP_ACTIONS.UPDATE_ADDITIONAL_REQUIREMENTS,
  payload: value,
});

export const resetApp = () => ({
  type: APP_ACTIONS.RESET_APP,
});

export const getLanguages = (responseCallback, errorCallback) => async () => {
  const successHandler = (response) => {
    responseCallback(response?.data || []);
  };

  const errorHandler = (error) => {
    errorCallback(updateLanguagesError(error));
  };

  try {
    const response = await fetchLanguages();
    response ? successHandler(response) : errorHandler(response.status);
  } catch (error) {
    errorHandler(httpErrorHandler(error));
  }
};

export const getServices = (responseCallback, errorCallback) => async () => {
  const successHandler = (response) => {
    responseCallback(response?.data || []);
  };

  const errorHandler = (error) => {
    errorCallback(updateServicesError(error));
  };

  try {
    const response = await fetchServices();
    response ? successHandler(response) : errorHandler(response.status);
  } catch (error) {
    errorHandler(httpErrorHandler(error));
  }
};

export const getCategories = (responseCallback, errorCallback) => async () => {
  const successHandler = (response) => {
    responseCallback(response?.data || []);
  };

  const errorHandler = (error) => {
    errorCallback(error);
  };

  try {
    const response = await fetchCategories();
    response ? successHandler(response) : errorHandler(response.status);
  } catch (error) {
    errorHandler(httpErrorHandler(error));
  }
};

export const getAutoEnrolmentStatus = (email, recaptcha, responseCallback, errorCallback) => async () => {
  const successHandler = (response) => {
    if (response) {
      responseCallback(response);
    }
  };

  const errorHandler = (error) => {
    errorCallback(error);
  };

  try {
    const params = {
      username: email,
      reCaptchaResponse: recaptcha,
    };
    const response = await checkAutoEnrolmentStatus(params);
    response ? successHandler(response) : errorHandler(response.status);
  } catch (error) {
    errorHandler(error);
  }
};

export const submitPriorityServicesForm = (journey, params, responseCallback, errorCallback) => async () => {
  const errorHandler = (error) => {
    errorCallback(error);
  };

  try {
    const response = await submitForm(journey, params);
    response ? responseCallback() : errorHandler(response.status);
  } catch (error) {
    errorHandler(error);
  }
};
